import { Timestamp } from "./Timestamp";
import { Attribution } from "./Attribution";
import { LastReported } from "./LastReported";
import { PropertyType } from "@/assets/scripts/PageEditor";
import { FirstReported } from "./FirstReported";
import { IocMalwareHash } from "./IocMalwareHash";
import { IocMalwareName } from "./IocMalwareName";
import { IocMalwareSandbox } from "./IocMalwareSandbox";
import { IocMalwareHashType } from "./IocMalwareHashType";
import { IocAssociateFileHash } from "./IocAssociatedFileHash";
import { IocMalwareDescription } from "./IocMalwareDescription";

export const IocsMalware = {
    id: "ioc_malware",
    name: "Malware",
    path: "*.iocs.malware",
    type: PropertyType.ComplexTable,
    layout: {
        summary: "{{ attribution }}\n**{{ ioc_malware_name }}**",
        rows: 6,
        cols: 10
    },
    properties: [
        {
            ...Attribution,
            row: 1,
            col: [1,5],
        },
        {
            ...IocMalwareName,
            row: 1,
            col: [6, 10]
        },
        {
            ...IocMalwareSandbox,
            row: 2,
            col: [1, 8]
        },
        {
            ...IocMalwareHashType,
            row: 2,
            col: [9, 10]
        },
        {
            ...IocMalwareHash,
            row: 3,
            col: [1, 10]
        },
        {
            ...IocAssociateFileHash,
            row: 4,
            col: [1, 10]
        },
        {
            ...IocMalwareDescription,
            row: 5,
            col: [1, 10]
        },
        {
            ...FirstReported,
            row: 6,
            col: [1,5]
        },
        {
            ...LastReported,
            row: 6,
            col: [6,10]
        },
    ]
}
